import { render, staticRenderFns } from "./goodsBrandSelect.vue?vue&type=template&id=ffb95170&scoped=true&"
import script from "./goodsBrandSelect.vue?vue&type=script&lang=js&"
export * from "./goodsBrandSelect.vue?vue&type=script&lang=js&"
import style0 from "./goodsBrandSelect.vue?vue&type=style&index=0&id=ffb95170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb95170",
  null
  
)

export default component.exports